import { membershipRuleKeys } from '../../constants/membership';
import { MembershipRuleValue } from '../../types/membership';
import { Ticket } from '../../types/ticket';
import { Rule } from '../types/Rule';
import { RuleContext } from '../types/RuleContext';

export class CheckMembershipFeedbackError implements Rule<MembershipRuleValue> {
  apply(context: RuleContext): MembershipRuleValue {
    const { membershipResponse, tickets, membership } = context;

    if (tickets && membership) return this.verifyMembershipHasTicket(tickets);
    if (!membershipResponse) return membershipRuleKeys.noMembership;

    const hasMembership = membershipResponse.memberships.length > 0;
    if (!hasMembership) return membershipRuleKeys.membershipNotFound;

    const membershipValue = membershipResponse.memberships[0];
    const isInactive = !membershipValue.canBuy || membershipValue.currentState === 'Inativo';
    if (isInactive) return membershipRuleKeys.inactivePlan;

    return membershipRuleKeys.success;
  }

  private verifyMembershipHasTicket(ticketGroups: Ticket[]) {
    const hasHiddenTicket = ticketGroups.some((ticketGroup) => (
      ticketGroup.salable &&
      ticketGroup.status === 'available' &&
      ticketGroup.type.some((ticket) => ticket.hidden && ticket.status === 'available')
    ));

    if (!hasHiddenTicket) return membershipRuleKeys.withoutTickets;

    return membershipRuleKeys.success;
  }
}
